module.exports = __webpack_public_path__ + "static/img/icono-manzana.01b238fc.svg";